import { useSearchParams, useNavigationAdapter } from '../../navigation';
import { resolveAuthUrl } from '../../lib/path-utils';
import { AuthLinkWrapper, AuthLinkText, AuthLinkLink } from './styled';

export interface AuthLinkProps {
  text: string;
  linkText: string;
  href: string;
}

/**
 * Call-to-action link component for navigation between auth pages.
 *
 * @component
 * @example
 * ```tsx
 * <AuthLink
 *   text="Don't have an account?"
 *   linkText="Sign up"
 *   href="/sign-up"
 * />
 * ```
 *
 * @param {string} text - Regular text before the link
 * @param {string} linkText - Clickable link text
 * @param {string} href - Link URL
 */
export function AuthLink({ text, linkText, href }: AuthLinkProps) {
  const searchParams = useSearchParams();
  const { Link } = useNavigationAdapter();

  // Resolve auth path with proper base path handling and preserve search params
  const finalHref = resolveAuthUrl(href, searchParams);

  return (
    <AuthLinkWrapper>
      {text && <AuthLinkText>{text}</AuthLinkText>}
      {text && ' '}
      <Link href={finalHref} className="">
        <AuthLinkLink as="span">{linkText}</AuthLinkLink>
      </Link>
    </AuthLinkWrapper>
  );
}
